var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 75,
    viewBox: "0 0 33 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H33V75H0V0ZM11.3232 28.5316C10.7534 27.9302 10.7791 26.9808 11.3805 26.4111C11.9819 25.8413 12.9313 25.867 13.501 26.4684L22.501 35.9684C23.0491 36.5469 23.0491 37.4531 22.501 38.0316L13.501 47.5316C12.9313 48.133 11.9819 48.1587 11.3805 47.5889C10.7791 47.0192 10.7534 46.0698 11.3232 45.4684L19.3459 37L11.3232 28.5316Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.909ef894d24c6f540e797adf3b06bec0.svg";
export { ForwardRef as ReactComponent };